var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDollarCircle = function SvgDollarCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 34 34",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.918 11.135c-.936 0-1.785.813-1.785 1.92 0 .754.162 1.099.306 1.282.154.196.412.37.921.551l6.049 2.101c.673.24 1.404.597 1.944 1.285.55.702.785 1.595.785 2.67 0 2.254-1.762 4.17-4.035 4.17h-3.765c-2.517 0-4.455-2.115-4.455-4.62a1.125 1.125 0 1 1 2.25 0c0 1.367 1.032 2.37 2.205 2.37h3.765c.936 0 1.785-.812 1.785-1.92 0-.753-.163-1.098-.306-1.281-.154-.197-.413-.37-.922-.552l-6.048-2.1c-.674-.24-1.404-.598-1.944-1.286-.55-.702-.785-1.594-.785-2.67 0-2.253 1.761-4.17 4.035-4.17h3.765c2.517 0 4.455 2.116 4.455 4.62a1.125 1.125 0 0 1-2.25 0c0-1.366-1.032-2.37-2.205-2.37h-3.765Z",
    fill: "#123862"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 6.875c.621 0 1.125.504 1.125 1.125v18a1.125 1.125 0 0 1-2.25 0V8c0-.621.504-1.125 1.125-1.125Z",
    fill: "#123862"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 3.125C9.337 3.125 3.125 9.337 3.125 17S9.337 30.875 17 30.875 30.875 24.663 30.875 17 24.663 3.125 17 3.125ZM.875 17C.875 8.094 8.095.875 17 .875c8.906 0 16.125 7.22 16.125 16.125 0 8.906-7.22 16.125-16.125 16.125C8.094 33.125.875 25.905.875 17Z",
    fill: "#123862"
  })));
};
export default SvgDollarCircle;